import { axiosContentDetail } from "../axios";
import { TIER_ACTIONS } from "./actionTypes";
import { getContentWithLanguage } from "../util/language";
import { handleActionError } from "../util/error";

const SubMenuUrl = "/api/v1/topicAndChild";
const SubMenuDataUrl = "/pub/api/v2/vod/topic";
const SponsoredByUrl = "/api/v1/cta";

export const getTierSubMenuAction = ({ id, language }) => {
  return dispatch => {
    dispatch({
      type: TIER_ACTIONS.SUB_MENU._START
    });
    return axiosContentDetail
      .get(`${SubMenuUrl}?id=${id}`)
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU._SUCCESS,
          payload: { data: filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting topic-and-child data:", error);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU._FAILURE
        });
      });
  };
};

export const getTierSubMenuDataAction = ({ id = 0, offset = 0, max = 6, token, language }) => {
  return dispatch => {
    dispatch({
      type: TIER_ACTIONS.SUB_MENU_VIDEO._START,
      payload: { offset }
    });
    let reqBody = {
      "id" : id,
      "offset" : offset,
      "max": max,
      "token" : token
    }
    return axiosContentDetail
      .post(`${SubMenuDataUrl}`, reqBody)
      .then(response => {
        const { data = {} } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU_VIDEO._SUCCESS,
          payload: { data: filteredByLanguage, offset }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting topic-related VOD data:", error);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU_VIDEO._FAILURE
        });
      });
  };
};

export const getSponsoredByIdAction = ({ id, language}) => {
  return dispatch => {
    dispatch({
      type: TIER_ACTIONS.SUB_MENU_SPONSORED_BY_VIDEO._START
    });
    return axiosContentDetail
      .get(`${SponsoredByUrl}?id=${id}`)
      .then(response => {
        const { data } = response;
        const filteredByLanguage = getContentWithLanguage(data.data, language);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU_SPONSORED_BY_VIDEO._SUCCESS,
          payload: { data: data && filteredByLanguage }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting CTA data:", error);
        dispatch({
          type: TIER_ACTIONS.SUB_MENU_SPONSORED_BY_VIDEO._FAILURE
        });
      });
  };
};

export const resetTierResults = id => {
  return dispatch => {
    dispatch({
      type: TIER_ACTIONS._RESET
    });
  };
};
